import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgCopyLine = (props) => /* @__PURE__ */ _jsx("svg", {
	width: "1em",
	height: "1em",
	viewBox: "0 0 24 24",
	fill: "currentColor",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "M19 2C20.1046 2 21 2.89543 21 4V16C21 17.1046 20.1046 18 19 18H17V20C17 21.1046 16.1046 22 15 22H5C3.89543 22 3 21.1046 3 20V8C3 6.89543 3.89543 6 5 6H7V4C7 2.89543 7.89543 2 9 2H19ZM15 8H5V20H15V8ZM10 15C10.5523 15 11 15.4477 11 16C11 16.5523 10.5523 17 10 17H8C7.44772 17 7 16.5523 7 16C7 15.4477 7.44772 15 8 15H10ZM19 4H9V6H15C16.1046 6 17 6.89543 17 8V16H19V4ZM12 11C12.5523 11 13 11.4477 13 12C13 12.5128 12.614 12.9355 12.1166 12.9933L12 13H8C7.44772 13 7 12.5523 7 12C7 11.4872 7.38604 11.0645 7.88338 11.0067L8 11H12Z" })
});
export default SvgCopyLine;
